import { useQuery } from '@tanstack/react-query'
import { FilterQuery, SaF } from '@yes.technology/react-toolkit'
import apiAsync from 'infrastructure/shared/api/api-async'
import { isEmpty } from 'lodash'

type UseSaFQueryProps = {
  filterQuery?: FilterQuery
  objectclassUuid?: string
}

type SaFProps = Pick<React.ComponentProps<typeof SaF>, 'columns' | 'data'> & {
  success: boolean
}

type DataResponse = {
  success: boolean
  columns?: SaFProps['columns']
  data?: {
    links?: SaFProps['data']['links']
    nodes?: SaFProps['data']['nodes']
  }
}

export const SAF_QUERY_REQUEST = {
  endpoint: 'msPlatform' as const,
  path: 'saf-chart' as const,
  method: 'POST' as const
}

export default function useSaFQuery({
  filterQuery,
  objectclassUuid
}: UseSaFQueryProps) {
  return useQuery<SaFProps>({
    queryKey: ['use-saf-query', filterQuery],
    queryFn: async () => {
      const result: DataResponse = await apiAsync.requestSync({
        ...SAF_QUERY_REQUEST,
        showLoading: false,
        obj: {
          query: filterQuery,
          objectclass: objectclassUuid,
          pagination: {},
          orderby: [
            {
              date_creation_row: 'desc'
            }
          ]
        }
      })

      const { columns = [], data, success } = result

      return {
        columns,
        data: {
          links: data?.links || [],
          nodes: data?.nodes || []
        },
        success: success
      }
    },
    enabled: !isEmpty(filterQuery)
  })
}
